export enum CustomDiscoveryCardCloudKeys {
  PREMIUM_UPSALE_KEY = 'lastInsertPremiumUpsaleCard'
}

export enum GeolocationCloudKeys {
  BROWSER_GEO_KEY = 'browserGeoRequestedAt',
  TELEGRAM_GEO_ACCESS_MODAL_KEY = 'telegramGeoRequestedAtModal'
}

export enum ProfileCloudKeys {
  MY_SPACE_VISITED = 'mySpaceVisited'
}

export enum PremiumCloudKeys {
  TELEGRAM_PREMIUM_UPSALE_MODAL_KEY = 'TELEGRAM_PREMIUM_UPSALE_MODAL_KEY'
}

export enum ReactionsUpsaleCloudKeys {
  REACTIONS_UPSALE_DATA = 'REACTIONS_UPSALE_DATA'
}
